import { contractsService } from './service'
import { createFetchHook } from '../../acato-utils'

export const contractsServiceHooks = createFetchHook(contractsService)
